export default __webpack_public_path__ + "static/media/potentially.a7c19390.svg";